import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/section-description.module.css';

interface SectionDescriptionProps extends TypographyProps {
    brand?: string | null;
}

function SectionDescription({ tag = 'div', brand, className, ...props }: SectionDescriptionProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([styles.container, styles[brand], className])}
            {...props}
        />
    );
}

export default SectionDescription;
